import React from 'react';

export const TsuMaxWaterHeightModal = {
  title: 'Maximum Water Height (m)',
  body: (
    <div>
      <p>The maximum water height above sea level in meters for this event. If the type of measurement of the runup was a:</p>
      <ul>
        <li>Tide Gauge - half of the maximum height (minus the normal tide) of a tsunami wave recorded at the coast by a tide gauge.</li>
        <li>Runup Height - the maximum elevation the wave reaches at the maximum inundation.</li>
      </ul>
    </div>
  ),
};
